import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { Input } from "@/src/components/ui/input";

export const YachtID = () => {
  return (
    <div className="w-full flex flex-col justify-end">
      <h4 className="text-sm font-normal col-span-full mb-1">Filter by ID</h4>
      <FormField<YachtsFiltersFormT, "yachtId">
        name="yachtId"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Input {...field} placeholder="Write an ID..." />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
